import { ReactElement, useEffect, useRef } from 'react';
import emitter, { EVENT } from '@client/common/utils/eventEmitter';
import { useUserData } from '@client/context/hooks';
import { FormikHelpers } from 'formik';
import { useClearRestockSubscribeAction, useRestockSubscribeAction } from 'b2b-apps/core/product/hooks';
import { Form } from './Form';
import { FIELD_NAME, FormValuesType, Props } from './FormContainer.types';

export const FormContainer = (props: Props): ReactElement => {
  const {
    sku,
  } = props;
  const restockSubscribeAction = useRestockSubscribeAction();
  const { profile: { email } } = useUserData();
  const clearRestockSubscribeAction = useClearRestockSubscribeAction();
  const setIsSubmittingRef = useRef<(isFulfilled: boolean) => void>();

  const handleClearIsSubmitting = () => {
    setIsSubmittingRef.current?.(false);
  };

  useEffect(() => {
    clearRestockSubscribeAction();
  }, []);

  useEffect(() => {
    emitter.on(EVENT.restockSubscribeFulfilled, handleClearIsSubmitting);
    emitter.on(EVENT.restockSubscribeRejected, handleClearIsSubmitting);

    return () => {
      emitter.off(EVENT.restockSubscribeFulfilled);
      emitter.off(EVENT.restockSubscribeRejected);
    };
  }, []);

  const handleSubmit = (values: FormValuesType, actions?: FormikHelpers<FormValuesType>): void => {
    setIsSubmittingRef.current = actions.setSubmitting;
    restockSubscribeAction({
      email: values[FIELD_NAME.email],
      sku,
    });

    clearRestockSubscribeAction();
  };

  return (
    <Form
      defaultEmail={email}
      onSubmit={handleSubmit}
      {...props}
    />
  );
};
